(() => {
  class DiscountCode extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('[data-copy-code]');
      const code = this.dataset.code;
      if (!button || !code || button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';

      button.addEventListener('click', async () => {
        const copied = button.getAttribute('data-copied') || 'Copied';
        const original = button.textContent;
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(code);
          } else {
            const field = document.createElement('textarea');
            field.value = code;
            field.setAttribute('readonly', '');
            field.style.position = 'absolute';
            field.style.left = '-9999px';
            document.body.appendChild(field);
            field.select();
            document.execCommand('copy');
            field.remove();
          }
          button.textContent = copied;
          button.classList.add('is-copied');
          window.setTimeout(() => {
            button.textContent = original;
            button.classList.remove('is-copied');
          }, 1800);
        } catch (err) {
          // keep original label if copy fails
        }
      });
    }
  }

  if (!customElements.get('discount-code')) {
    customElements.define('discount-code', DiscountCode);
  }
})();
